var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE361ArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.728 4.01328L24.0004 10.2857C24.1855 10.4707 24.315 10.665 24.389 10.8685C24.463 11.072 24.5 11.2848 24.5 11.5069C24.5 11.7289 24.463 11.9465 24.389 12.1596C24.315 12.372 24.1855 12.5708 24.0004 12.7558L17.728 19.0004C17.395 19.3335 16.9831 19.5 16.4924 19.5C16.0025 19.5 15.591 19.3335 15.2579 19.0004C14.9249 18.6674 14.7584 18.2603 14.7584 17.7793C14.7584 17.2982 14.9249 16.8819 15.2579 16.5303L18.5329 13.2554L3.24045 13.2554C2.75938 13.2554 2.34788 13.0844 2.00595 12.7425C1.66328 12.3998 1.49195 11.9879 1.49195 11.5069C1.49195 11.0258 1.66328 10.6143 2.00595 10.2724C2.34788 9.92969 2.75938 9.75836 3.24045 9.75836L18.5329 9.75835L15.2579 6.48338C14.9249 6.15034 14.7584 5.73847 14.7584 5.24778C14.7584 4.75783 14.9249 4.34633 15.2579 4.01328C15.591 3.66173 16.0025 3.49076 16.4924 3.50039C16.9831 3.50927 17.395 3.68023 17.728 4.01328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE361ArrowLeft);
export default __webpack_public_path__ + "static/media/e361-arrow-left.43945ddacb23c67e4dabd65ee9f0752d.svg";
export { ForwardRef as ReactComponent };